export const NETWORK = {
  OPDEV: 'opdev',
  SB: 'sb',
  RC: 'rc',
  STAGE: 'stage',
  LIVE: 'live'
};

export const SEARCH_API_DOMAIN = {
  //[NETWORK.OPDEV]: 'http://opdev-api-search.plaync.com',
  [NETWORK.OPDEV]: 'https://api-search.sb.plaync.com',
  [NETWORK.SB]: 'https://api-search.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-api-search.plaync.com',
  [NETWORK.STAGE]: 'https://api-search.plaync.com',
  [NETWORK.LIVE]: 'https://api-search.plaync.com',
};

export const CHATBOT_API_DOMAIN = {
  [NETWORK.SB]: 'https://api-chatbot.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-api-chatbot.plaync.com',
  [NETWORK.STAGE]: 'https://api-chatbot.plaync.com',
  [NETWORK.LIVE]: 'https://api-chatbot.plaync.com',
};
export const CHATBOT_DOMAIN = {
  [NETWORK.SB]: 'https://chatbot.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-chatbot.plaync.com',
  [NETWORK.STAGE]: 'https://stage-chatbot.plaync.com',
  [NETWORK.LIVE]: 'https://chatbot.plaync.com',
};